import { render, staticRenderFns } from "./IconQuestions.vue?vue&type=template&id=0409630e&"
import script from "./IconQuestions.vue?vue&type=script&lang=js&"
export * from "./IconQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports